import http from '../http'

export default {
  getList(params) {
    const url = `/versions`
    return http.get(url, { params })
  }
}
